import {
  RDX_EXP_SAVE_SUBMIT,
  RDX_EXP_DATA_UPDATE_DONE,
  RDX_EXP_DATA_UPDATE_ERR,
  RDX_EXP_UPLOAD_CERTIFICATE_DONE,
  RDX_EXP_UPLOAD_CERTIFICATE_ERR,
  RDX_EXP_QUESTIONNAIRE_FETCH,
  RDX_EXP_QUESTIONNAIRE_FETCH_DONE,
  RDX_EXP_QUESTIONNAIRE_FETCH_ERROR,
  RDX_EXP_RESULT_FETCH,
  RDX_EXP_RESULT_FETCH_DONE,
  RDX_EXP_RESULT_FETCH_ERROR,
  RDX_EXP_DOWNLOAD_FILE_DONE,
  RDX_EXP_QUESTIONNAIRE_CLEAN_ERROR,
} from './expAction';

const initialState = {
  expList: {},
  expResult: null,
  docResults: [],
  groupCodes: [],
  docId: '',
  params: '',
  backQuery: '',
  saveResult: 0,
  uploadResult: 0,
  errorInfo: [],
  file: '',
};

const expr = (state = initialState, action) => {
  let newState = {...state};
  switch (action.type) {
    case RDX_EXP_QUESTIONNAIRE_CLEAN_ERROR:
      newState = {
        ...state,
        saveResult: 0,
        uploadResult: 0,
        errorInfo: [],
      };
      return newState;
    case RDX_EXP_QUESTIONNAIRE_FETCH:
      return state;
    case RDX_EXP_QUESTIONNAIRE_FETCH_DONE:
      newState = {
        ...state,
        expList: action.data.questionList,
        docResults: action.data.docResults,
        docId: action.docId,
      };
      return newState;
    case RDX_EXP_QUESTIONNAIRE_FETCH_ERROR:
      newState = {...state, errorInfo: action.errorInfo};
      return newState;
    case RDX_EXP_RESULT_FETCH:
      return state;
    case RDX_EXP_RESULT_FETCH_DONE:
      newState = {...state, expResult: action.data};
      return newState;
    case RDX_EXP_RESULT_FETCH_ERROR:
      newState = {...state, errorInfo: action.errorInfo};
      return newState;
    case RDX_EXP_SAVE_SUBMIT:
      return state;
    case RDX_EXP_UPLOAD_CERTIFICATE_DONE:
      newState = {...state, uploadResult: action.data};
      return newState;
    case RDX_EXP_UPLOAD_CERTIFICATE_ERR:
      newState = {...state, uploadResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_EXP_DATA_UPDATE_DONE:
      newState = {...state, saveResult: action.data};
      return newState;
    case RDX_EXP_DATA_UPDATE_ERR:
      newState = {...state, saveResult: action.data, errorInfo: action.errorInfo};
      return newState;
    case RDX_EXP_DOWNLOAD_FILE_DONE:
      newState = {...state, file: action.data};
      return newState;
    default:
      return state;
  }
};

export default expr;
